/*       */
import AbstractGml from './AbstractGml';

export default class Style extends AbstractGml {
    getName() {
        return this.getAttributeValue('name');
    }
}
